/**
 * Small accessibility strings shared across components (screen-reader hints,
 * media and motion controls). Kept here so JSX carries no hardcoded copy.
 *
 * Added 2026-10-16 with the WCAG 2.2 AA launch-blocker fixes.
 */

/** Appended (visually hidden) to every link that opens a new tab. */
export const NEW_TAB_HINT = '(opens in a new tab)';

/** Pause / play toggle for auto-moving content (WCAG 2.2.2). */
export const MOTION_CONTROL_LABELS = {
  pauseMarquee: 'Pause scrolling text',
  playMarquee: 'Play scrolling text',
  pauseVideo: 'Pause preview video',
  playVideo: 'Play preview video',
} as const;

/** Accessible name prefix for the verified-review source chip when linked. */
export const REVIEW_SOURCE_LINK_SUFFIX = 'read this review';
